const CustomCheckBox = ({
  checked,
  onClick,
  disabled = false,
}: {
  checked: boolean;
  onClick: () => void;
  disabled?: boolean;
}) => (
  <div
    onClick={() => (disabled ? null : onClick())}
    className={`custom-checkbox-container ${disabled ? 'checkbox-disabled' : ''}`}
  >
    <input type="checkbox" checked={checked} disabled={disabled} />
    <span className={`checkmark`} />
  </div>
);

export default CustomCheckBox;
